// 調證協查頁面翻譯
export default {
  title: "調證協查",
  tips: {
    investigationInfo: "調證信息",
    investigationLimit:
      "（每次調證建議查詢信息不建議超過10條，以免調證結果返回時間過長）",
  },
  form: {
    platformType: "平台類型（必填）",
    operationType: "操作類型（必填）",
    selectPlatform: "選擇平台（必填）",
    priority: "調證優先級",
    addressInfo: "地址信息",
    addressVerify: "地址校對",
    withdrawHash: "提幣哈希",
    hashVerify: "哈希校對",
    identityInfo: "身份信息",
    identityVerify: "身份校對",
    remark: "備註",
    relatedCase: "關聯案件",
  },
  placeholders: {
    selectPlatformType: "請選擇平台類型",
    selectOperationType: "請選擇操作類型",
    selectPlatform: "請選擇平台",
    selectInstitution: "請選擇機構",
    selectChain: "請輸入鏈",
    selectCase: "請選擇案件",
    addressInfo: `請填寫已掌握的交易地址，多個地址換行分割，最大不超過50個地址
示例：
TNUC9Qb1rRpS5CbWLmNMxXBjyFoydXjWFR
TSUUVjysXV8YqHytSNjfkNXnnB49QDvZpx`,
    hashInfo: `請填寫已掌握的提幣哈希，多個哈希換行分割，最大不超過50條提幣哈希
示例：
c45ee90b9e5d850ac799740d6137b5b9f52e26e51ead132e459f5fc06fc89b73
b556473f9030cf2c1bb176f5aad11786419c41aff865a710b0a0d20976617df2`,
    identityInfo: `請填寫已掌握的身份信息，多個身份信息換行分割，最大不超過50條身份信息
示例：
Binance-xxxxxx
Binance-xxxxxx
`,
    remark: "請輸入備註，如調證原因等…",
    selectRelatedCase: "請選擇關聯案件",
  },
  buttons: {
    addressRecognize: "地址識別",
    hashRecognize: "哈希識別",
    identityRecognize: "身份識別",
    generateDocument: "生成調證文書",
    batchImport: "批量導入",
    downloadTemplate: "模版下載",
  },
  messages: {
    chainRequired: "鏈必填",
    addSuccess: "新增成功",
    uploadExcelOnly: "只能上傳excel的文件",
    tagNotSupport: "該標簽暫不支持批量上傳",
  },
  validation: {
    institutionTypeRequired: "機構類型為必填項",
    operationTypeRequired: "操作類型為必填項",
    priorityRequired: "優先級為必填項",
    platformRequired: "機構為必填項",
    chainRequired: "鏈為必填項",
  },
  documentfile: {
    title: "文書預覽",
    buttons: {
      download: "下載調證文書",
      previous: "上一步",
    },
    preview: "調證文書預覽",
    loading: "拼命加載中",
    info: {
      email: "調證郵箱：",
      emailTitle: "建議調證郵箱標題：",
      emailAttachment: "調證郵件附件材料：",
      notes: "其他注意事項：",
      none: "暫無",
    },
    notesList: {
      note1: "1.去中心化錢包服務商的用戶資產無法凍結",
      note2:
        "2.調證的數據範圍時間範圍盡量明確，建議是調取所有時長內的信息和操作記錄",
      note3:
        "3.建議向平台明確調取的數據材料返回格式要為Excel，嚴禁圖片和PDF格式",
      note4: "4.需要要求平台加蓋公司電子公章，以便後續做證據固定使用",
      note5:
        "5.針對海外交易所，為提升調證的成功率，建議使用gov.cn等政府郵箱發送調證",
    },
    downloadFilename: "案件調取證據通知書",
  },
};
